import React from 'react'
import styled, { css } from 'styled-components'
import './card.scss'

const IssueCard = (props) => {
    const { item, filterHighlight, navigateToIssue } = props
    const severityLabels = {
        1: 'Critical',
        2: 'High',
        3: 'Medium',
        4: 'Low',
        5: 'Information',
    }
    return (
        <React.Fragment key={item.name}>
            <div
                class="
				mt-3 sm:mt-6 
				sm:w-full"
            >
                <div
                    class="flex p-6
                transition duration-150 ease-in-out 
                border-2 border-gray-200 hover:border-info-active issue-detail-content 
                sm:flex-row flex-col items-center"
                >
                    <div
                        class="
						w-full sm:w-11/12 
						flex-grow 
						 "
                    >
                        <div
                            className=" text-issue-card-title text-neutral-gray-700 font-bold mb-2"
                            // onClick={navigateToIssue}
                        >
                            {item.pretty_name}
                        </div>
                        <div className="mb-6 flex flex-wrap items-center">
                            <div
                                className={`px-2 py-1 flex items-center rounded bg-neutral-gray-50 border border-neutral-gray-200 text-severity-${item.severity}`}
                            >
                                <div
                                    className={`w-5 h-5 rounded-md text-sm-label font-semibold flex items-center justify-center text-white bg-severity-${item.severity}`}
                                >
                                    {item.severity}
                                </div>
                                <div
                                    className={` pl-2 text-sm-label font-semibold text-severity-${item.severity}`}
                                >
                                    {severityLabels[item.severity]} Severity
                                </div>
                            </div>
                            <div
                                className={`ml-3 px-2 py-1 leading-5 flex items-center rounded bg-neutral-gray-50 border border-neutral-gray-200 text-sm-label font-semibold text-neutral-gray-500`}
                            >
                                {item.category}
                            </div>
                        </div>
                        <div
                            class="mt-6 text-issue-card-desc text-neutral-gray-400"
                            // onClick={navigateToIssue}
                        >
                            {item.description}
                        </div>
                        {/* {item?.references?.length > 0 && (
              <div className="reference-lists mt-4">
                <p className="sm:text-md lg:text-base"> Links: </p>
                <ul>
                  {item.references.map((link, index) => (
                    <React.Fragment key={index}>
                      <li>
                        <a
                          className="text-primary-400 hover:underline"
                          target="_"
                          href={link.uri}
                        >
                          {link.uri}
                        </a>
                      </li>
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            )} */}
                    </div>
                    <div></div>
                    <div
                        className="
            w-full sm:w-1/12
            "
                    >
                        <div className="font-semibold text-sm-label text-neutral-gray-400">
                            Release Date
                        </div>
                        <div className="mt-2 text-navigation-link">
                            {item.added}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default IssueCard
